import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import PillSpinner from '../components/PillSpinner';

const API_URL = 'http://localhost:5000/api';

const EditMedicine = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [suppliers, setSuppliers] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    stock: '',
    price: '',
    expiryDate: '',
    reorderLevel: 10,
    supplierId: ''
  });
  const [loading, setLoading] = useState(true);

  // Fetch suppliers and medicine data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [suppliersRes, medicinesRes] = await Promise.all([
          axios.get(`${API_URL}/suppliers`),
          axios.get(`${API_URL}/medicines`)
        ]);
        setSuppliers(suppliersRes.data);
        const medicine = medicinesRes.data.find(m => m._id === id);
        if (medicine) {
          setFormData({
            name: medicine.name,
            stock: medicine.stock,
            price: medicine.price,
            expiryDate: medicine.expiryDate ? medicine.expiryDate.split('T')[0] : '',
            reorderLevel: medicine.reorderLevel || 10,
            supplierId: medicine.supplierId || ''
          });
        } else {
          alert('Medicine not found');
          navigate('/');
        }
      } catch (err) {
        console.error(err);
        alert('Error fetching data');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id, navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API_URL}/medicines/${id}`, {
        name: formData.name,
        stock: parseInt(formData.stock),
        price: parseFloat(formData.price),
        expiryDate: formData.expiryDate,
        reorderLevel: parseInt(formData.reorderLevel),
        supplierId: formData.supplierId || null
      });
      alert('Medicine updated successfully!');
      navigate('/');
    } catch (err) {
      alert('Error updating medicine');
    }
  };

  if (loading) return <PillSpinner />;

  return (
    <div className="card">
      <h2>✏️ Edit Medicine</h2>
      <form onSubmit={handleSubmit} className="medicine-form">
        <input type="text" name="name" placeholder="Medicine name" value={formData.name} onChange={handleChange} required />
        <input type="number" name="stock" placeholder="Stock quantity" value={formData.stock} onChange={handleChange} required />
        <input type="number" step="0.01" name="price" placeholder="Price (₹)" value={formData.price} onChange={handleChange} required />
        <input type="date" name="expiryDate" value={formData.expiryDate} onChange={handleChange} required />
        <input type="number" name="reorderLevel" placeholder="Reorder when stock below" value={formData.reorderLevel} onChange={handleChange} required />
        
        {/* Supplier dropdown */}
        <select name="supplierId" value={formData.supplierId} onChange={handleChange}>
          <option value="">Select Supplier (optional)</option>
          {suppliers.map(sup => (
            <option key={sup._id} value={sup._id}>{sup.name}</option>
          ))}
        </select>
        
        <button type="submit" className="btn-submit">Update Medicine</button>
        <button type="button" className="btn-add" onClick={() => navigate('/')} style={{ background: '#6c757d' }}>Cancel</button>
      </form>
    </div>
  );
};

export default EditMedicine;